var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5858 10.3079L16.5 15.2221L15.2221 16.5L10.3079 11.5858C9.39022 12.2461 8.28388 12.6492 7.07461 12.6492C3.99571 12.6492 1.5 10.1535 1.5 7.07461C1.5 3.99571 3.99571 1.5 7.07461 1.5C10.1535 1.5 12.6492 3.99571 12.6492 7.07461C12.6492 8.28388 12.2461 9.39022 11.5858 10.3079ZM7.07461 3.21527C4.93911 3.21527 3.21527 4.93911 3.21527 7.07461C3.21527 9.21012 4.93911 10.934 7.07461 10.934C9.21012 10.934 10.934 9.21012 10.934 7.07461C10.934 4.93911 9.21012 3.21527 7.07461 3.21527Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23691 7.81579L6.23691 9.39474H7.81585L7.81585 7.81579L9.3948 7.81579V6.23685L7.81585 6.23685V4.6579L6.23691 4.6579L6.23691 6.23685L4.65796 6.23685L4.65796 7.81579L6.23691 7.81579Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoom-icon.5f93844b5851324dc5277c02275b6626.svg";
export { ForwardRef as ReactComponent };